import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('incomes-payments', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('incomes-payments/metrics', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('incomes-payments', payload, config),
  customerPendingSelectors: (params = {}, config = {}) => axios.get('incomes-payments/customers/pending-selectors', { params, ...config }),
  applicationItems: (params = {}, config = {}) => axios.get('incomes-payments/application-items', { params, ...config }),
  show: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}`, { params, ...config }),
  downloadPdf: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/pdf`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadZip: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/zip`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadXml: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/xml`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadRequestsLatest: (params = {}, config = {}) => axios.get('incomes-payments/download-requests/latest', { params, ...config }),
  downloadRequestsShow: (requestId, params = {}, config = {}) => axios.get(`incomes-payments/download-requests/${requestId}`, { params, ...config }),
  downloadRequestsStore: (payload = {}, config = {}) => axios.post('incomes-payments/download-requests', payload, config),
  downloadRequestsDirectDownload: (payload = {}, config = {}) => axios.post(
    'incomes-payments/download-requests/direct-download',
    payload,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  downloadRequestsRetryPackage: (requestId, packageId, payload = {}, config = {}) => axios.post(
    `incomes-payments/download-requests/${requestId}/packages/${packageId}/retry`,
    payload,
    config,
  ),
  downloadRequestsRegenerate: (requestId, payload = {}, config = {}) => axios.post(
    `incomes-payments/download-requests/${requestId}/regenerate`,
    payload,
    config,
  ),
  downloadRequestsDownloadPackage: (requestId, packageId, params = {}, config = {}) => axios.get(
    `incomes-payments/download-requests/${requestId}/packages/${packageId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  exportColumns: (config = {}) => axios.get('incomes-payments/exports/columns', config),
  exportFormats: (config = {}) => axios.get('incomes-payments/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('incomes-payments/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`incomes-payments/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`incomes-payments/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('incomes-payments/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  sendPaymentReceipt: (id, payload = {}, config = {}) => axios.post(`send/payment-receipts/${id}`, payload, config),
  activity: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/activity`, { params, ...config }),
  shippingIndex: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/shipping`, { params, ...config }),
  documentsIndex: (id, params = {}, config = {}) => axios.get(`incomes-payments/${id}/documents`, { params, ...config }),
  documentsDownload: (id, documentId, params = {}, config = {}) => axios.get(
    `incomes-payments/${id}/documents/${documentId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  documentsStore: (id, payload = {}, config = {}) => axios.post(`incomes-payments/${id}/documents`, payload, config),
  documentsUpdate: (id, documentId, payload = {}, config = {}) => axios.put(`incomes-payments/${id}/documents/${documentId}`, payload, config),
  documentsDelete: (id, documentId, config = {}) => axios.delete(`incomes-payments/${id}/documents/${documentId}`, config),
  documentsDownloadAll: (id, params = {}, config = {}) => axios.get(
    `incomes-payments/${id}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
};
